export { };

declare global {
	interface String {
		startsWithEmptyString(): boolean;
	}
}

String.prototype.startsWithEmptyString = function (this: string): boolean {
	return /^\s+/.test(this);
}